import { Box, Button, IconButton, Tooltip } from '@material-ui/core';
import { Clear } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import {
  DragIcon,
  EditIconTwoTone,
  PlayIconTwoTone,
  RemoveIconTwoTone,
  Typography,
} from '@room-match/shared-ui-components';
import { FormikProps, useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { CustomTypography } from 'shared/elements/CustomTypography';
import IMedia from 'shared/interfaces/IMedia';
import { IResumeCredit } from 'shared/interfaces/IResume';
import { ICredit } from 'shared/interfaces/ITalent';
import { GENERATE_DATES } from 'shared/utils/common';
import * as yup from 'yup';
import MediaBinModal from '../../../../shared/components/MediaBinModal/MediaBinModal';
import {
  ActionsContainer,
  AddMediaButton,
  CreditItemContainer,
  CustomTextInput,
  MainCont,
  ViewMediaButton,
  useStyles,
  StyledSaveIcon,
} from './CreditItem.styles';
import { COLORS } from 'shared/constants/COLORS';
const { ERROR_ICON, ERROR_TEXT } = COLORS;

interface Props {
  item: ICredit;
  modifyCredit: (d: ICredit | {}) => void;
  edit: (stat: boolean) => void;
  isPhotographer: boolean;
  hideYears: boolean;
}
const CreditItem: React.FC<Props> = ({ item, modifyCredit, edit, isPhotographer, hideYears }) => {
  const classes = useStyles();
  const [showAttachedMedia, setShowAttachedMedia] = useState(false);
  const [selectedMedia, setselectedMedia] = useState<IMedia[]>(item.attached_media);
  const [editMode, setEditMode] = useState(false);
  const [checkError, setcheckError] = useState(false);
  const [showBin, setShowBin] = useState(false);

  const textFieldYear: any = React.useRef(null);
  const textFieldTitle: any = React.useRef(null);
  const textFieldRole: any = React.useRef(null);
  const textFieldDirector: any = React.useRef(null);
  const addMediaRef: any = React.useRef(null);

  const { title, year, role, director, attached_media } = item;

  const editMedia = (media: IMedia[]) => {
    setselectedMedia(media);
    modifyCredit({ ...item, attached_media: media });
  };

  const initialValues: any = {
    year,
    title,
    director,
    role,
    attached_media,
  };

  const createResumeValidationSchema: yup.SchemaOf<any> = yup.object().shape({
    // representation_type: yup.mixed<RepresentationType>().oneOf(Object.values(RepresentationType)).required(),
    year: yup.number().required(),
    title: yup.string().required(),
    director: yup.string().required(),
    role: yup.string().required(),
    attached_media: yup.array(),
  });

  const handleSubmit = async (values: IResumeCredit, helpers: any) => {
    modifyCredit({ ...values, attached_media: selectedMedia });
    // helpers.resetForm();
    // setselectedMedia([]);
    setEditMode(false);
  };

  const form: FormikProps<IResumeCredit> = useFormik({
    initialValues,
    validationSchema: createResumeValidationSchema,
    onSubmit: (values, helpers) => {
      handleSubmit(values, helpers);
      return;
    },
  });

  useEffect(() => {
    edit(editMode);
  }, [editMode]);

  return (
    <MainCont>
      <DragIcon style={{ height: 18 }} className="drag-icon" />
      {editMode ? (
        <Box style={{ flexDirection: 'column', width: '100%' }}>
          <CreditItemContainer>
            <Autocomplete
              value={{
                key: form.values.year.toString(),
                value: form.values.year,
              }}
              id="resume-year-credit-item"
              onChange={(e, value: any) => {
                if (value && value?.key) {
                  form.setFieldValue('year', value.key);
                }
              }}
              options={GENERATE_DATES}
              ListboxProps={{ style: { maxHeight: 250 } }}
              noOptionsText="Invalid Year"
              classes={{ option: classes.option }}
              getOptionLabel={(option: any) => option.key}
              renderOption={(option: any) => {
                return <p style={{ fontSize: 16 }}>{option.value}</p>;
              }}
              renderInput={(params: any) => (
                <CustomTextInput
                  error={checkError && form.errors.year !== undefined}
                  inputRef={textFieldYear}
                  placeholder="Year"
                  {...params}
                  inputProps={{
                    ...params.inputProps,
                    onKeyPress: (event) => {
                      const { key } = event;
                      if (key === 'Enter') {
                        console.log(params);

                        textFieldTitle.current.focus();
                      }
                    },
                  }}
                />
              )}
            />
            <CustomTextInput
              error={checkError && form.errors.title !== undefined}
              inputRef={textFieldTitle}
              size="small"
              fullWidth
              style={{ flex: 1, margin: '0px 5px' }}
              placeholder="Title"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              name="title"
              value={form.values.title}
              onChange={form.handleChange}
              inputProps={{
                onKeyPress: (event) => {
                  const { key } = event;
                  if (key === 'Enter') {
                    textFieldRole.current.focus();
                  }
                },
              }}
            />
            <CustomTextInput
              error={checkError && form.errors.role !== undefined}
              inputRef={textFieldRole}
              size="small"
              fullWidth
              style={{ flex: 1, margin: '0px 5px' }}
              placeholder="Role"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              name="role"
              value={form.values.role}
              onChange={form.handleChange}
              inputProps={{
                onKeyPress: (event) => {
                  const { key } = event;
                  if (key === 'Enter') {
                    textFieldDirector.current.focus();
                  }
                },
              }}
            />
            <CustomTextInput
              error={checkError && form.errors.director !== undefined}
              inputRef={textFieldDirector}
              size="small"
              fullWidth
              style={{ flex: 1, margin: '0px 5px' }}
              placeholder={`${isPhotographer ? 'Photographer' : 'Director'}`}
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              name="director"
              value={form.values.director}
              onChange={form.handleChange}
              inputProps={{
                onKeyPress: (event) => {
                  const { key } = event;
                  if (key === 'Enter') {
                    addMediaRef.current.click();
                  }
                },
              }}
            />
            <AddMediaButton ref={addMediaRef} onClick={() => setShowBin(true)}>
              Add Media
            </AddMediaButton>
            <ActionsContainer>
              <Tooltip title="Save">
                <IconButton
                  style={{ padding: 5, marginLeft: -12 }}
                  onClick={() => {
                    setcheckError(true);
                    form.handleSubmit();
                  }}
                >
                  <StyledSaveIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Cancel">
                <IconButton
                  style={{ padding: 0 }}
                  onClick={() => {
                    form.handleReset();
                    setselectedMedia(item.attached_media);
                    setEditMode(false);
                  }}
                >
                  <Clear style={{ color: ERROR_ICON }} />
                </IconButton>
              </Tooltip>
            </ActionsContainer>
          </CreditItemContainer>
          {checkError && Object.keys(form.errors).length > 0 && (
            <Typography style={{ color: ERROR_TEXT }} fontSize={14}>
              *All fields are required
            </Typography>
          )}
          {selectedMedia.length ? (
            <Box style={{ display: 'flex', alignItems: 'center', margin: '0 10px 10px 10px', marginLeft: 'auto' }}>
              <p style={{ fontSize: 16 }}> {selectedMedia.length} Media Attached : </p>
              <ViewMediaButton onClick={() => setShowAttachedMedia(true)} disabled={selectedMedia.length === 0}>
                View Media
              </ViewMediaButton>
            </Box>
          ) : (
            <></>
          )}
        </Box>
      ) : (
        <CreditItemContainer>
          {!hideYears && (
            <Typography color="primary" style={{ fontSize: 15 }}>
              {year}
            </Typography>
          )}
          <p style={{ fontSize: 16 }}>{title}</p>
          <p style={{ fontSize: 16 }}>{role}</p>
          <CustomTypography>{director}</CustomTypography>
          <Button
            style={{ backgroundColor: 'transparent', marginRight: 15, marginLeft: -8 }}
            onClick={() => setShowAttachedMedia(true)}
            disabled={selectedMedia.length === 0}
          >
            <PlayIconTwoTone
              style={{ marginRight: 8, width: 18, height: 18, opacity: selectedMedia.length === 0 ? 0.5 : 1 }}
            />
            {`View Media(${attached_media?.length || 0})`}
          </Button>
          <ActionsContainer>
            <Tooltip title="Edit">
              <IconButton
                style={{ padding: 5 }}
                onClick={() => {
                  console.log('edit', item);

                  setEditMode(!editMode);
                  setselectedMedia(item.attached_media);
                }}
              >
                <EditIconTwoTone style={{ width: 18, height: 18 }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton onClick={() => modifyCredit({})} style={{ padding: 5 }}>
                <RemoveIconTwoTone style={{ width: 18, height: 18 }} />
              </IconButton>
            </Tooltip>
          </ActionsContainer>
        </CreditItemContainer>
      )}

      {showBin && (
        <MediaBinModal
          selected={selectedMedia}
          show={showBin}
          close={() => setShowBin(false)}
          setSelected={setselectedMedia}
        />
      )}
      {showAttachedMedia && (
        <MediaBinModal
          attachedMedia
          selected={selectedMedia}
          show={showAttachedMedia}
          close={() => setShowAttachedMedia(false)}
          setSelected={editMode ? setselectedMedia : editMedia}
        />
      )}
    </MainCont>
  );
};

export default CreditItem;
